import { ArrowArcLeft } from '@phosphor-icons/react';

export default ArrowArcLeft;
